import fetch from "@lib/fetch";

import type { CheckDateFilterImpactsParams, CheckDateFilterImpactsResult } from "./types";

export const checkDateFilterImpacts = (
  params: CheckDateFilterImpactsParams
): Promise<CheckDateFilterImpactsResult> => {
  return fetch("/companies/workspaces_time_zones/check_date_filter_impacts", "GET", params);
};
